import { FieldCheckBox } from '@components/field-builder/field-checkbox';
import { BorderedGridItem } from '@containers/form-i9/styles';
import { Grid } from '@material-ui/core';
import {
    getSpacingGrades,
    SpacingGrade
} from '@styles/spacing-styles';
import { themeProvider } from '@swipejobs/frontend-theme-provider';
import * as React from 'react';
import { JSXElementConstructor } from 'react';
import styled, { css } from 'styled-components';

export const DocumentDetailGridItem = styled(BorderedGridItem).attrs(props => ({
    direction: 'row',
    alignItems: 'flex-start',
    container: props.container ?? true
}))`
  padding: 10px;
`;

export const DocumentDetailLabel = styled.span`
  margin-top: 14px;
  font-size: ${() => themeProvider.getTypography().font.size.small};
`;

export const DocumentDetailLabelGridItem = styled(Grid).attrs({
    item: true
})`
  && {
      margin-top: 15px;
      margin-right: 10px;
  }
`;

type ExtendReactComponentProps<
    C extends JSXElementConstructor<React.ComponentProps<C>>,
    T
> = React.ComponentType<React.ComponentProps<C> & T>;

export const PaddableBorderedGridItem = styled<ExtendReactComponentProps<typeof BorderedGridItem, {
    padding: SpacingGrade;
}>>(BorderedGridItem).attrs(props => ({
    container: props.container ?? true,
    direction: props.direction ?? 'column'
}))`
  && {
      padding: ${({ padding }) => getSpacingGrades()[padding]}px;
  }
`;

export const PartialBorderGridItem = styled<ExtendReactComponentProps<typeof Grid, {
    showBottomBorder?: boolean;
}>>(({ showBottomBorder, ...props }) => <Grid {...props} />).attrs({
    item: true
})`
  padding: 10px;
  max-width: 100%;
  ${({ showBottomBorder }) => showBottomBorder === true && css`border-bottom: 2px solid rgba(0, 0, 0, 0.3)`};
`;

const betweenSiblings = (insert: any) => css`
  && > * + * {
    ${insert};
  }
`;

export const ListADocumentGrid = styled(Grid).attrs({
    container: true
})`
  border-right: 8px solid gray;
  ${betweenSiblings(css`border-top: 4px solid black`)};  
`;

export const ThinSeparator = styled.div`
  width: 100%;
  height: 2px;
  background-color: black;
`;

export const FadeableFieldCheckbox = styled<
    ExtendReactComponentProps<typeof FieldCheckBox, { faded?: boolean; }>
>(FieldCheckBox)`
  ${({ faded }) => faded === true && `opacity: 0.3`};
`;



// WEBPACK FOOTER //
// ./src/containers/form-i9/document-details-list/styles.tsx